import { Box } from "@mui/material";

import BlueAgreeIcon from "assets/icons/sticky_note/ic_memo_bl_agree.svg";
import BlueAntiIcon from "assets/icons/sticky_note/ic_memo_bl_anti.svg";
import BlueCartIcon from "assets/icons/sticky_note/ic_memo_bl_cart.svg";
import BlueCautionIcon from "assets/icons/sticky_note/ic_memo_bl_caution.svg";
import BlueConeIcon from "assets/icons/sticky_note/ic_memo_bl_cone.svg";
import BlueKeyIcon from "assets/icons/sticky_note/ic_memo_bl_key.svg";
import BlueNormalIcon from "assets/icons/sticky_note/ic_memo_bl_normal.svg";
import BlueParkingIcon from "assets/icons/sticky_note/ic_memo_bl_parking.svg";
import BluePersonIcon from "assets/icons/sticky_note/ic_memo_bl_person.svg";
import BluePostIcon from "assets/icons/sticky_note/ic_memo_bl_post.svg";
import BlueSaleIcon from "assets/icons/sticky_note/ic_memo_bl_sale.svg";
import BlueSecretIcon from "assets/icons/sticky_note/ic_memo_bl_secret.svg";
import RedAgreeIcon from "assets/icons/sticky_note/ic_memo_re_agree.svg";
import RedAntiIcon from "assets/icons/sticky_note/ic_memo_re_anti.svg";
import RedCartIcon from "assets/icons/sticky_note/ic_memo_re_cart.svg";
import RedCautionIcon from "assets/icons/sticky_note/ic_memo_re_caution.svg";
import RedConeIcon from "assets/icons/sticky_note/ic_memo_re_cone.svg";
import RedKeyIcon from "assets/icons/sticky_note/ic_memo_re_key.svg";
import RedNormalIcon from "assets/icons/sticky_note/ic_memo_re_normal.svg";
import RedParkingIcon from "assets/icons/sticky_note/ic_memo_re_parking.svg";
import RedPersonIcon from "assets/icons/sticky_note/ic_memo_re_person.svg";
import RedPostIcon from "assets/icons/sticky_note/ic_memo_re_post.svg";
import RedSaleIcon from "assets/icons/sticky_note/ic_memo_re_sale.svg";
import RedSecretIcon from "assets/icons/sticky_note/ic_memo_re_secret.svg";
import WhiteAgreeIcon from "assets/icons/sticky_note/ic_memo_wh_agree.svg";
import WhiteAntiIcon from "assets/icons/sticky_note/ic_memo_wh_anti.svg";
import WhiteCartIcon from "assets/icons/sticky_note/ic_memo_wh_cart.svg";
import WhiteCautionIcon from "assets/icons/sticky_note/ic_memo_wh_caution.svg";
import WhiteConeIcon from "assets/icons/sticky_note/ic_memo_wh_cone.svg";
import WhiteKeyIcon from "assets/icons/sticky_note/ic_memo_wh_key.svg";
import WhiteNormalIcon from "assets/icons/sticky_note/ic_memo_wh_normal.svg";
import WhiteParkingIcon from "assets/icons/sticky_note/ic_memo_wh_parking.svg";
import WhitePersonIcon from "assets/icons/sticky_note/ic_memo_wh_person.svg";
import WhitePostIcon from "assets/icons/sticky_note/ic_memo_wh_post.svg";
import WhiteSaleIcon from "assets/icons/sticky_note/ic_memo_wh_sale.svg";
import WhiteSecretIcon from "assets/icons/sticky_note/ic_memo_wh_secret.svg";
import YellowAgreeIcon from "assets/icons/sticky_note/ic_memo_ye_agree.svg";
import YellowAntiIcon from "assets/icons/sticky_note/ic_memo_ye_anti.svg";
import YellowCartIcon from "assets/icons/sticky_note/ic_memo_ye_cart.svg";
import YellowCautionIcon from "assets/icons/sticky_note/ic_memo_ye_caution.svg";
import YellowConeIcon from "assets/icons/sticky_note/ic_memo_ye_cone.svg";
import YellowKeyIcon from "assets/icons/sticky_note/ic_memo_ye_key.svg";
import YellowNormalIcon from "assets/icons/sticky_note/ic_memo_ye_normal.svg";
import YellowParkingIcon from "assets/icons/sticky_note/ic_memo_ye_parking.svg";
import YellowPersonIcon from "assets/icons/sticky_note/ic_memo_ye_person.svg";
import YellowPostIcon from "assets/icons/sticky_note/ic_memo_ye_post.svg";
import YellowSaleIcon from "assets/icons/sticky_note/ic_memo_ye_sale.svg";
import YellowSecretIcon from "assets/icons/sticky_note/ic_memo_ye_secret.svg";

import { StickyNote, StickyNoteColor, StickyNoteIcon } from "graphql/API";
import React from "react";
import styles from "./StickyNoteItemIcon.module.scss";

export const StickyNoteItemIcon = React.memo(
  (props: { stickyNote: StickyNote }) => {
    let icon = WhiteNormalIcon;

    switch (props.stickyNote.color) {
      case StickyNoteColor.white:
        switch (props.stickyNote.icon) {
          case StickyNoteIcon.normal:
            icon = WhiteNormalIcon;
            break;
          case StickyNoteIcon.parking:
            icon = WhiteParkingIcon;
            break;
          case StickyNoteIcon.key:
            icon = WhiteKeyIcon;
            break;
          case StickyNoteIcon.cone:
            icon = WhiteConeIcon;
            break;
          case StickyNoteIcon.caution:
            icon = WhiteCautionIcon;
            break;
          case StickyNoteIcon.secret:
            icon = WhiteSecretIcon;
            break;
          case StickyNoteIcon.sale:
            icon = WhiteSaleIcon;
            break;
          case StickyNoteIcon.cart:
            icon = WhiteCartIcon;
            break;
          case StickyNoteIcon.person:
            icon = WhitePersonIcon;
            break;
          case StickyNoteIcon.post:
            icon = WhitePostIcon;
            break;
          case StickyNoteIcon.anti:
            icon = WhiteAntiIcon;
            break;
          case StickyNoteIcon.agree:
            icon = WhiteAgreeIcon;
            break;
        }
        break;

      case StickyNoteColor.blue:
        switch (props.stickyNote.icon) {
          case StickyNoteIcon.normal:
            icon = BlueNormalIcon;
            break;
          case StickyNoteIcon.parking:
            icon = BlueParkingIcon;
            break;
          case StickyNoteIcon.key:
            icon = BlueKeyIcon;
            break;
          case StickyNoteIcon.cone:
            icon = BlueConeIcon;
            break;
          case StickyNoteIcon.caution:
            icon = BlueCautionIcon;
            break;
          case StickyNoteIcon.secret:
            icon = BlueSecretIcon;
            break;
          case StickyNoteIcon.sale:
            icon = BlueSaleIcon;
            break;
          case StickyNoteIcon.cart:
            icon = BlueCartIcon;
            break;
          case StickyNoteIcon.person:
            icon = BluePersonIcon;
            break;
          case StickyNoteIcon.post:
            icon = BluePostIcon;
            break;
          case StickyNoteIcon.anti:
            icon = BlueAntiIcon;
            break;
          case StickyNoteIcon.agree:
            icon = BlueAgreeIcon;
            break;
        }
        break;

      case StickyNoteColor.yellow:
        switch (props.stickyNote.icon) {
          case StickyNoteIcon.normal:
            icon = YellowNormalIcon;
            break;
          case StickyNoteIcon.parking:
            icon = YellowParkingIcon;
            break;
          case StickyNoteIcon.key:
            icon = YellowKeyIcon;
            break;
          case StickyNoteIcon.cone:
            icon = YellowConeIcon;
            break;
          case StickyNoteIcon.caution:
            icon = YellowCautionIcon;
            break;
          case StickyNoteIcon.secret:
            icon = YellowSecretIcon;
            break;
          case StickyNoteIcon.sale:
            icon = YellowSaleIcon;
            break;
          case StickyNoteIcon.cart:
            icon = YellowCartIcon;
            break;
          case StickyNoteIcon.person:
            icon = YellowPersonIcon;
            break;
          case StickyNoteIcon.post:
            icon = YellowPostIcon;
            break;
          case StickyNoteIcon.anti:
            icon = YellowAntiIcon;
            break;
          case StickyNoteIcon.agree:
            icon = YellowAgreeIcon;
            break;
        }
        break;

      case StickyNoteColor.red:
        switch (props.stickyNote.icon) {
          case StickyNoteIcon.normal:
            icon = RedNormalIcon;
            break;
          case StickyNoteIcon.parking:
            icon = RedParkingIcon;
            break;
          case StickyNoteIcon.key:
            icon = RedKeyIcon;
            break;
          case StickyNoteIcon.cone:
            icon = RedConeIcon;
            break;
          case StickyNoteIcon.caution:
            icon = RedCautionIcon;
            break;
          case StickyNoteIcon.secret:
            icon = RedSecretIcon;
            break;
          case StickyNoteIcon.sale:
            icon = RedSaleIcon;
            break;
          case StickyNoteIcon.cart:
            icon = RedCartIcon;
            break;
          case StickyNoteIcon.person:
            icon = RedPersonIcon;
            break;
          case StickyNoteIcon.post:
            icon = RedPostIcon;
            break;
          case StickyNoteIcon.anti:
            icon = RedAntiIcon;
            break;
          case StickyNoteIcon.agree:
            icon = RedAgreeIcon;
            break;
        }
        break;
    }

    return (
      <Box
        component="img"
        src={icon}
        alt={`${props.stickyNote.color || ""}_${props.stickyNote.icon || ""}`}
        className={styles.icon}
      />
    );
  }
);
